import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MarketingHeader } from "./MarketingHeader";
import { MarketingFooter } from "./MarketingFooter";

export default function PublicLayout() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* WCAG 2.4.1 Bypass Blocks — skip link (visible on keyboard focus). */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded focus:bg-background focus:px-3 focus:py-2 focus:text-foreground focus:shadow focus:ring-2 focus:ring-ring"
      >
        {t("common.skipToContent", { defaultValue: "Aller au contenu principal" })}
      </a>
      <MarketingHeader />
      <main id="main-content">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
